import type { OktaAuth } from '@okta/okta-auth-js';

import { environment } from '../../environment';
import { updateLocalStorage, updateSessionStorage } from '../storage';

/**
 * Sign out from Okta and redirect user to the app login page.
 *
 * - Uses `fibiPath` from sessionStorage when available (integration with host app)
 * - Falls back to configured `server.path` (e.g. `/food/onboarding`) for local/dev
 */
export function logoutAndRedirectToLogin(oktaAuth: OktaAuth): void {
  // Read fibiPath directly from sessionStorage (not the utility wrapper).
  // The host app (MyCargill) may store the value with surrounding quotes,
  // so we strip them — same approach TrackerPage uses.
  const rawFibiPath = sessionStorage.getItem('fibiPath');
  const fibiPath = rawFibiPath ? rawFibiPath.replace(/['"]+/g, '') : null;

  const signOutPromise = oktaAuth && typeof oktaAuth.signOut === 'function' ? oktaAuth.signOut() : Promise.resolve();
  
  signOutPromise
    .catch(() => {
      // Ignore signOut errors - we'll redirect anyway
    })
    .finally(() => {
      const { server } = environment();
      const basePath = fibiPath || server?.path || '';
      updateSessionStorage.clear();
      updateLocalStorage.clear();
      window.location.href = `${basePath}/login`;
    });
}
